module.exports = __webpack_public_path__ + "img/img_navigation_map.8b22fbcc.png";